export default "__VITE_ASSET__D0hxyvR0__"